<main class="p-4 container-lg">
  <div class="row">
    <div class="col-12 col-md-6 offset-md-3">
      <h2>Forgot Password</h2>
      @if (!complete){
      <p>Enter your email and we will send you instructions on how to reset your password.</p>
      <form [formGroup]="form" (ngSubmit)="submit()">
        <div class="form-group row mb-3">
          <div class="col">
            <label for="email" class="form-label">Email</label>
            <input type="text" tabindex="1" class="form-control" placeholder="user@email.com" formControlName="email">
            <div class="text-danger" *ngIf="formControl.email.touched && formControl.email.errors?.required">
              Email is required
            </div>
          </div>
        </div>
        
        <div class="row mt-3">
          <div class="col-12 col-sm-6">
            <button type="submit" tabindex="3" class="btn btn-primary px-5" [disabled]="working">
              <i class="fa-solid fa-lock" [class]="{'fa-paper-plane': !working, 'fa-spinner': working, 'fa-spin': working}"></i> Send Instructions
            </button>
          </div>
          <div class="col-12 col-sm-6 text-end">
            <a routerLink="/login">Back to login</a>
          </div>
        </div>
      </form>
      }
      @else if(complete){
      <p>
        You should receive an email shortly with instructions on resetting your password. Be sure to check your junk folder.
        To ensure you are receiving email communications from GT Pro Tune, please add no-reply&#64;gtprotune.com to your allow list.
      </p>

      <a routerLink="/login">Back to login</a>
      }
    </div>
  </div>
</main>
